/**
 * scrollUtils.ts
 * 
 * Utility functions for smooth scrolling to DOM elements
 */

/**
 * Smooth scroll to an element by its ID
 * 
 * @param elementId - The ID of the element to scroll to
 * @returns void
 */
export const scrollToElement = (elementId: string): void => {
	const element = document.getElementById(elementId);
	if (element) {
		element.scrollIntoView({ behavior: 'smooth' });
	}
};
